import React, { useState } from "react";
import { Form, Col, Row, Button, Card } from "react-bootstrap";

const Filter = ({
  user,
  allData,
  handleGetPeriod,
  setStartDate,
  setEndDate,
  ultimoClicado,
  filterData,
  lastData,
  startDate,
  endDate,
  handledata,
  permissionSGU,
}) => {

  const handleChangeStartDate = (event) => {
    const rawDate = new Date(event.target.value);
    rawDate.setHours(0, 0, 0, 0); // Define para 00:00:00
    setStartDate(event.target.value); // Converte para ISO para padronizar
  };

  const handleChangeEndDate = (event) => {
    const rawDate = new Date(event.target.value);
    rawDate.setHours(23, 59, 59, 999); // Define para 23:59:59.999
    setEndDate(event.target.value); // Converte para ISO para padronizar
  };

  function diasNosMeses(meses) {
    const hoje = new Date();
    const dataAtras = new Date(hoje.getFullYear(), hoje.getMonth() - meses, hoje.getDate());
    const diferencaEmMilissegundos = hoje - dataAtras;
    const diferencaEmDias = diferencaEmMilissegundos / (1000 * 60 * 60 * 24);
    return diferencaEmDias.toFixed(0) - 1;
  }

  const quantidadeDeDiasTresMeses = diasNosMeses(3);

  // Controle local para exibir datas somente quando "Personalizado" estiver ativo
  const [customAtivo, setCustomAtivo] = useState(false);

  // Ao selecionar um atalho de dias, limpar datas customizadas e enviar apenas 'days'
  const callPreset = (days, index) => {
    setCustomAtivo(false);
    setStartDate(null);
    setEndDate(null);
    handleGetPeriod(days, index, filterData);
  };

  return (
    <Card className="mb-2 mt-2 p-2 filters-panel">
      <Card.Body style={{ padding: 8 }}>
        <Row className="g-2 align-items-center">
          <Col className="d-flex flex-wrap align-items-center">

            <Button
              className="me-2"
              onClick={() => callPreset(1, 0)}
              variant={ultimoClicado === 0 ? "success" : "outline-success"}
              disabled={!permissionSGU?.report?.write}
              size="sm"
            >
              1 dia
            </Button>

            <Button
              className="me-2"
              onClick={() => callPreset(7, 1)}
              variant={ultimoClicado === 1 ? "success" : "outline-success"}
              disabled={!permissionSGU?.report?.write}
              size="sm"
            >
              7 dias
            </Button>

            <Button
              className="me-2"
              onClick={() => callPreset(15, 15)}
              variant={ultimoClicado === 15 ? "success" : "outline-success"}
              disabled={!permissionSGU?.report?.write}
              size="sm"
            >
              15 dias
            </Button>

            <Button
              className="me-2"
              onClick={() => callPreset(30, 2)}
              variant={ultimoClicado === 2 ? "success" : "outline-success"}
              disabled={!permissionSGU?.report?.write}
              size="sm"
            >
              30 dias
            </Button>

            <Button
              className="me-2"
              onClick={() => callPreset(60, 2)}
              variant={ultimoClicado === 2 ? "success" : "outline-success"}
              disabled={!permissionSGU?.report?.write}
              size="sm"
            >
              60 dias
            </Button>

            <Button
              className="me-2"
              onClick={() => callPreset(quantidadeDeDiasTresMeses, 3)}
              variant={ultimoClicado === 3 ? "success" : "outline-success"}
              disabled={!permissionSGU?.report?.write}
              size="sm"
            >
              3 meses
            </Button>

            <Button
              className="me-2"
              onClick={() => setCustomAtivo(true)}
              variant={customAtivo ? "success" : "outline-success"}
              disabled={!permissionSGU?.report?.write}
              size="sm"
            >
              Personalizado
            </Button>

            {customAtivo && (
              <>
                <Form.Control
                  className="border-success me-2 text-success"
                  style={{ width: 150 }}
                  type="date"
                  value={startDate ? startDate.slice(0, 10) : ''}
                  onChange={handleChangeStartDate}
                  disabled={!permissionSGU?.report?.write}
                  size="sm"
                />

                <Form.Control
                  className="border-success me-2 text-success"
                  style={{ width: 150 }}
                  type="date"
                  value={endDate ? endDate.slice(0, 10) : ''}
                  onChange={handleChangeEndDate}
                  disabled={!permissionSGU?.report?.write}
                  size="sm"
                />

                <Button
                  onClick={handledata}
                  variant="success"
                  disabled={!permissionSGU?.report?.write}
                  size="sm"
                >
                  Buscar
                </Button>
              </>
            )}
          </Col>
        </Row>

      </Card.Body>
    </Card>
  )
}

export default React.memo(Filter);
